import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Cookies from "universal-cookie";
import { Icon } from "../../atoms/icon";

import styles from "./styles.m.css";

const cookies = new Cookies();

export class StoryNewsletter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newsletter: new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(cookies.get("vikatan[email]"))
        ? cookies.get("vikatan[email]")
        : "",
      msg: "",
      status: 0,
      inputValid: true,
      newsletterView: false
    };
    this.configureData = this.configureData.bind(this);
    this.updateTemplateAttribute = this.updateTemplateAttribute.bind(this);
  }

  updateTemplateAttribute(name, value) {
    this.setState({
      [name]: value,
      inputValid: true
    });
  }

  configureData() {
    const vuid = cookies.get("vuid");
    const story = this.props.story;
    const itself = this;
    const current = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(current.getFullYear() + 1);

    const req = {
      email: this.state.newsletter,
      url: story.url,
      vuid: vuid || ""
    };

    if (new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.newsletter) === false) {
      itself.setState({
        inputValid: false
      });
      return false;
    }

    axios.get(`https://special.vikatan.com/newsletter/newsletter-api.php`, { params: req }).then(res => {
      if (res.status === 200 && res.data) {
        itself.setState({
          msg: res.data.msg,
          status: res.data.status
        });

        setTimeout(() => {
          if (vuid) {
            if (res.data.status === "0")
              cookies.set("newsletter-status", true, { domain: ".vikatan.com", expires: nextYear });

            itself.setState({
              newsletterView: res.data.status !== "1"
            });
          }
        }, 4000);
      }
    });
  }

  render() {
    const { msg, newsletterView, status, inputValid } = this.state;
    const emailClass = inputValid ? "email" : "error-email";

    return (
      <div>
        {status !== "0" ? (
          <div className={styles["newsLetter-container"]}>
            <div styleName="widget-header" className={styles["component-wrapper"]}>
              <div className={styles["content-sec"]}>
                <Icon type="newslettericon" />
                <p className={styles["widget-description"]}>
                  உள்ளூர் வைரல் முதல் உலக டிரெண்ட் வரை உடனடியாக உங்கள் மெயிலில்!
                </p>
              </div>
              <div className={styles["from-outer-sec"]}>
                <input
                  type="email"
                  placeholder={"Enter Email ID & Get Vikatan Updates"}
                  value={this.state.newsletter}
                  onChange={e => this.updateTemplateAttribute("newsletter", e.target.value)}
                  ref={input => {
                    this.nameInput = input;
                  }}
                  className={styles[emailClass]}
                />
                <div className={styles["input-wrapper-submit"]}>
                  <a
                    aria-label="submit"
                    role="button"
                    className={styles["submit-configure"]}
                    onClick={this.configureData}
                  >
                    Submit
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {newsletterView === false && msg ? (
          <div className={styles["newsLetter-error-container"]}>
            <div className={styles["errorInfo"]}>{msg}</div>
          </div>
        ) : (
          " "
        )}
      </div>
    );
  }
}

export default StoryNewsletter;

StoryNewsletter.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string
  })
};
